import React from 'react'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'

interface VisionFieldProps {
  value: string
  onChange: (value: string) => void
}

const VisionField = ({ value, onChange }: VisionFieldProps) => {
  return (
    <div className="flex flex-col gap-3">
      <Label htmlFor="productVision" className="text-sm font-medium">
        Product Vision
      </Label>
      <Textarea
        id="productVision"
        placeholder="A one-sentence vision statement summarizing the product's long-term goal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="bg-white min-h-[80px] resize-none"
        rows={2}
      />
    </div>
  )
}

export default VisionField
